<div class="toast-card-container" [style.top]="top" role="status">
    <div class="toast-card">
        <button type="button" class="toast-card-close" aria-label="Close" (click)="closed.emit()">
            <i class="fa-solid fa-xmark"></i>
        </button>
        <div class="toast-card-icon">
            <app-hexagon-logo [size]="22"></app-hexagon-logo>
        </div>
        <div class="toast-card-content">
            <div class="toast-card-title">{{ heading }}</div>
            <ng-content></ng-content>
        </div>
    </div>
</div>
